require('./bootstrap');

require('./daterangepicker/daterangepicker.css');
require('./daterangepicker/daterangepicker');
// require('./offline/offline');
// require('./offline/offline-theme-default.css');
// require('./offline/offline-language-english.css');


import KProgress from 'k-progress';
Vue.component('k-progress', KProgress);




import VueSignature from "vue-signature-pad";
Vue.use(VueSignature);
Vue.config.productionTip = false;


// import * as moment from 'moment';
// import daterangepicker from "./daterangepicker/daterangepicker"


window.$ = require('jquery')
window.JQuery = require('jquery')
window.Vue = require('vue');

import VueRouter from 'vue-router'
Vue.use(VueRouter)

var converter = require('number-to-words');

Vue.filter('toWords', function (value) {
    if (!value) return '';
    return converter.toWords(value).toUpperCase();
})



import moment from 'moment';
moment.suppressDeprecationWarnings = true;

Vue.filter('myDate', function (created) {
    return moment(created).format('MMMM DD YYYY');
});

Vue.filter('MM/DD/YYYY', function (value) {
    if (!value) return ''
    return moment(value).format('MM/DD/YYYY');
});


Vue.filter('datetime', function (value) {
    if (!value) return ''
    return moment(value).format('MM/DD/YYYY LT');
});

Vue.filter('date_aps', function (value) {
    if (!value) return ''
    return moment(value).format('DD MMM YYYY');
});
Vue.filter('date_soa', function (value) {
    if (!value) return ''
    return moment(value).format('MMM YYYY');
});

Vue.filter('accounting', function (value) {
    var absValue = Math.abs(value);
    var returnString = new Intl.NumberFormat('en-US', { signDisplay: 'never', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(absValue)

    // Number(absValue).toLocaleString('en-US', {
    //     signDisplay: 'never',
    //     minimumFractionDigits: 2
    // });
    return value < 0 ? '(' + returnString + ')' : returnString;
});


Vue.filter('shortname', function (n) {
    let ext = n.substring(n.lastIndexOf(".") + 1, n.length).toLowerCase();
    let filename = n.replace('.' + ext, '');
    if (filename.length <= 8) {
        return n;
    }
    filename = filename.substr(0, 8) + (n.length > 8 ? '[...]' : '');
    return filename + '.' + ext;
});

Vue.filter('uppercase', function (text) {
    if (!text) return ''
    return text.toUpperCase();
});


import Vue from 'vue';
import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);


import Inputmask from "./inputmask";
Vue.directive('input-mask', {
    bind: function (el, obj, vModel) {
        Inputmask().mask(el);
    }
})
import VueCurrencyFilter from 'vue-currency-filter'

Vue.use(VueCurrencyFilter, [{ // default name 'currency'
    symbol: '₱',
    thousandsSeparator: ',',
    fractionCount: 0,
    fractionSeparator: '.',
    symbolPosition: 'front',
    symbolSpacing: true
},
{ // default name 'currency_2'
    name: 'decimal',
    symbol: '₱',
    thousandsSeparator: ',',
    fractionCount: 2,
    fractionSeparator: '.',
    symbolPosition: 'front',
    symbolSpacing: true
},
{
    name: 'curr',
    symbol: '',
    thousandsSeparator: ',',
    fractionCount: 2,
    fractionSeparator: '.',
    symbolPosition: 'front',
    symbolSpacing: false,
    avoidEmptyDecimals: undefined,
}
])


import Swal from 'sweetalert2'
window.Swal = Swal
// import toast from 'sweetalert2'

const toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 2000,
    timerProgressBar: true,
    onOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
})

window.toast = toast;

Vue.component('side-bar', require('./components/public/includes/SideBar.vue').default);
Vue.component('bottom-bar', require('./components/public/includes/BottomBar.vue').default);


Vue.component('public-topbar', require('./components/public//includes/TopBar.vue').default);
Vue.component('baguio-topbar', require('./components/partners/baguio/TopBar.vue').default);
Vue.component('hor-topbar', require('./components/partners/hor/TopBar.vue').default);
Vue.component('pcci-topbar', require('./components/partners/pcci/TopBar.vue').default);
Vue.component('philexport-topbar', require('./components/partners/philexport/TopBar.vue').default);
Vue.component('quadx-topbar', require('./components/partners/quadx/TopBar.vue').default);
Vue.component('lazada-topbar', require('./components/partners/lazada/TopBar.vue').default);
Vue.component('heroes-topbar', require('./components/partners/heroes/TopBar.vue').default);
Vue.component('cares1-topbar', require('./components/partners/cares1/TopBar.vue').default);


Vue.component('data-table', require('./components/public/table/Datatable.vue').default);

Vue.component('reset-password', require('./components/public/ResetPassword.vue').default);
Vue.component('reg-password', require('./components/public/RegPassword.vue').default);
Vue.component('forgot-account', require('./components/public/Security/ForgotAccount.vue').default);
Vue.component('create-account', require('./components/public/CreateAccount/index.vue').default);
Vue.component('email-verify', require('./components/public/EmailView/verify.vue').default);

import VueCountdown from '@chenfengyuan/vue-countdown';
Vue.component(VueCountdown.name, VueCountdown);


Vue.component('date-range-picker', {
    props: ['id', 'maxDate', 'minDate', 'startDate'],
    template: '<input type="text" autocomplete="off" :id="id" :name="id"/>',
    mounted: function () {
        var self = this;
        var input = $('input[name="' + this.id + '"]');
        input.daterangepicker({
            showDropdowns: true,
            singleDatePicker: true,
            minDate: this.minDate,
            maxDate: this.maxDate,
            startDate: this.startDate,
            autoUpdateInput: true,
            emptyDate: true,
        });

        input.on('input', function () {
            self.$emit('input', $(this).val());
        });

        input.on('apply.daterangepicker', function (ev, picker) {
            self.$emit('input', picker.startDate.format('MM/DD/YYYY'));
            $(this).val(picker.startDate.format('MM/DD/YYYY'));
        });
    }
});
Vue.component('input-calendar', { //daterangepicker
    props: {
        id: {
            type: String,
            required: true
        },
        value: {
            type: String,
        },
        startDate: {
            type: String,
            default: moment().format('MM/DD/YYYY')
        },
        maxDate: {
            type: String,
            default: moment().endOf('year').format('MM/DD/YYYY')
        },
        minDate: {
            type: String,
            default: '01/01/1900'
        },
    },
    template: '<input :id="id" :name="id" type="text" autocomplete="off" placeholder="mm/dd/yyyy"/>',
    mounted: function () {
        var self = this;
        var input = $('input[name="' + this.id + '"]');

        input.daterangepicker({
            showDropdowns: true,
            singleDatePicker: true,
            autoUpdateInput: true,
            emptyDate: true,
            locale: {
                format: 'MM/DD/YYYY'
            },

            minDate: this.minDate,
            maxDate: this.maxDate,
            startDate: this.value ? moment(this.value).format('MM/DD/YYYY') : this.startDate,
        });

        // Event listener for changes in the input value
        input.on('change', function (e) {
            var inputValue = $(this).val();
            if (moment(inputValue, 'MM/DD/YYYY', true).isValid()) {
                self.$emit('input', moment(inputValue, 'MM/DD/YYYY').format('YYYY-MM-DD'));
            } else {
                self.$emit('input', inputValue);
            }
        });

        // If the value prop is provided, set the display value in the input field
        if (this.value) {
            const formats = [
                'YYYY-MM-DD',
                'YYYY-MM-DD HH:mm:ss',
                'YYYY-MM-DDTHH:mm:ssZ' // ISO 8601 format with timezone
            ];

            if (moment(this.value, formats, true).isValid()) {
                var displayValue = moment(this.value).format('MM/DD/YYYY');
                input.val(displayValue);
            }
        }
        // Event listener for the date picker apply event
        input.on('apply.daterangepicker', function (ev, picker) {
            $(this).val(picker.startDate.format('MM/DD/YYYY'));
            self.$emit('input', picker.startDate.format('YYYY-MM-DD'));
        });
    },
    watch: {
        value: function (newValue) {
            if (newValue) {
                if (newValue.includes('-')) {
                    if (moment(newValue, 'YYYY-MM-DD', true).isValid()) {
                        var el = $('input[name="' + this.id + '"]');
                        var formattedValue = moment(newValue, 'YYYY-MM-DD').format('MM/DD/YYYY');
                        el.data('daterangepicker').setStartDate(formattedValue);
                        el.data('daterangepicker').setEndDate(formattedValue);
                        el.val(formattedValue);
                    }
                }
            }
        }
    }
});



//npm install vue-currency-input
//npm install @vue/composition-api
import { watch } from '@vue/composition-api'
import { useCurrencyInput } from 'vue-currency-input'
Vue.component('input-currency', {
    name: 'InputCurrency',
    props: {
        value: Number, // Vue 2: value
        options: {
            type: Object,
            default: () => ({
                currency: 'USD', currencyDisplay: 'hidden'
            }),
        },
    },
    setup(props) {
        const { inputRef, setOptions, setValue } = useCurrencyInput(props.options)
        watch(
            () => props.value, // Vue 2: props.value
            (value) => {
                setValue(value)
            }
        )
        watch(
            () => props.options,
            (options) => {
                setOptions(options)
            }
        )
        return { inputRef }
    },
    template: '<input ref="inputRef" type="text" />'
})

import VueProgressBar from 'vue-progressbar'

Vue.use(VueProgressBar, {
    color: 'rgb(143, 255, 199)',
    failedColor: 'red',
    height: '2px'
});

// loader
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
Vue.component('loading', Loading);




let routes = [
    { path: '/cares2-application', component: require('./components/public/Application.vue').default },
    { path: '/new-application', component: require('./components/public/NewApplication.vue').default },

    { path: '/loan-releasing', component: require('./components/public/LoanReleasing.vue').default },
    { path: '/dashboard', component: require('./components/public/Dashboard.vue').default },
    { path: '/profile', component: require('./components/public/Profile.vue').default },
    { path: '/business', component: require('./components/public/Business.vue').default },
    // { path: '/apply-loan', component: require('./components/public/ApplyLoan.vue').default },

    { path: '/corporate', component: require('./components/public/Corporation.vue').default },
    // { name: 'prereg', path: '/pre-reg', component: require('./components/public/PreRegistration.vue').default },
    { name: 'prereg', path: '/pre-reg', component: require('./components/public/PreRegistration/index.vue').default },
    // { path: '/new-apply-loan', component: require('./components/public/ApplyLoanNew.vue').default },

    { path: '/brave-application', component: require('./components/partners/baguio/Application.vue').default },
    { path: '/lazada-application', component: require('./components/partners/lazada/Application.vue').default },
    { path: '/philexport-application', component: require('./components/partners/philexport/Application.vue').default },
    { path: '/pcci-application', component: require('./components/partners/pcci/Application.vue').default },
    { path: '/quadx-application', component: require('./components/partners/quadx/Application.vue').default },
    { path: '/hor-application', component: require('./components/partners/hor/Application.vue').default },
    { path: '/heroes-application', component: require('./components/partners/heroes/Application.vue').default },
    { path: '/cares1-application', component: require('./components/partners/cares1/Application.vue').default },
    // { path: '/loan-releasing', component: require('./components/partners/cares1/LoanReleasing.vue').default }

    { path: '/heroes-dashboard', component: require('./components/partners/heroes/Dashboard.vue').default },
    { path: '/apply-loan', pathToRegexpOptions: { strict: true }, component: require('./components/public/ApplyLoan/ApplyLoan.vue').default },
    { path: '/apply-loan/b2c', component: require('./components/public/ApplyLoan/B2C/LoanB2C.vue').default },
    { path: '/apply-loan/actoo', component: require('./components/public/ApplyLoan/Actoo/LoanActoo.vue').default },
    { path: '/apply-loan/heroes', component: require('./components/public/ExampleComponent.vue').default },
    { path: '/heroes', component: require('./components/public/ExampleComponent.vue').default },


    { path: '/apply-loan/staples', component: require('./components/public/ApplyLoan/Staples/LoanB2C.vue').default },
    { path: '/apply-loan/13th-month', component: require('./components/public/ApplyLoan/Month13/LoanB2C.vue').default },
    { path: '/apply-loan/erf-odette', component: require('./components/public/ApplyLoan/ERF/LoanB2C.vue').default },

    // { path: '/apply-loan/rise-up', component: require('./components/public/ApplyLoan/RISEUP/LoanB2C.vue').default },
    // { path: '/apply-loan/rise-up-ft', component: require('./components/public/ApplyLoan/RISEUP_FT/LoanB2C.vue').default },
    // { path: '/apply-loan/rise-up-turismo', component: require('./components/public/ApplyLoan/RISEUP_Turismo/LoanB2C.vue').default },
    // { path: '/apply-loan/rise-up-suki', component: require('./components/public/ApplyLoan/RISEUP_Suki/LoanB2C.vue').default },
    { path: '/apply-loan/rise-up-tindahan', component: require('./components/public/ApplyLoan/RISEUP_Tindahan/LoanB2C.vue').default },
    // { path: '/apply-loan/rise-up-month13', component: require('./components/public/ApplyLoan/RISEUP_Month13/LoanB2C.vue').default },

    { path: '/bills-payments', component: require('./components/public/APS/LoanAccounts.vue').default },

    { path: '/apply-loan/sblaf-rise-up-ft', component: require('./components/public/ApplyLoan/SBLAF/FirstTimer/index.vue').default },

    { path: '/apply-loan/sblaf-rise-up-mp', component: require('./components/public/ApplyLoan/SBLAF/MultiPurpose/index.vue').default },
    { path: '/apply-loan/sblaf-rise-up-suki', component: require('./components/public/ApplyLoan/SBLAF/Suki/index.vue').default },

    { path: '/apply-loan/erf', component: require('./components/public/ApplyLoan/SBLAF/Carina/index.vue').default },
    { path: '/apply-loan/startup', component: require('./components/public/ApplyLoan/SBLAF/Startup/index.vue').default },
    { path: '/apply-loan/franchising', component: require('./components/public/ApplyLoan/SBLAF/Franchising/index.vue').default },
    { path: '/apply-loan/po-financing', component: require('./components/public/ApplyLoan/SBLAF/Financing/index.vue').default },



    { path: '/apply-loan/sblaf-falah-ft', component: require('./components/public/ApplyLoan/SBLAF/FirstTimer/index.vue').default },
    { path: '/apply-loan/sblaf-falah-mp', component: require('./components/public/ApplyLoan/SBLAF/MultiPurpose/index.vue').default },
    { path: '/apply-loan/sblaf-falah-suki', component: require('./components/public/ApplyLoan/SBLAF/Suki/index.vue').default },
    // { path: '/dashboard', component: require('./components/public/Dashboard/Dashboard.vue').default },
    // { path: '/bills-payments', component: require('./components/public/APS/Billing.vue').default },
    // { path: '/send-quick', component: require('./components/public/SendQuick2.vue').default },
    // { path: '/email-update/:id', component:  require('./components/public/EmailView/update.vue').default },

    { path: '/apply-loan/sblaf-women-enterprise-fund-mp', component: require('./components/public/ApplyLoan/SBLAF/MultiPurpose/index.vue').default },
    { path: '/apply-loan/sblaf-women-enterprise-fund-ft', component: require('./components/public/ApplyLoan/SBLAF/FirstTimer/index.vue').default },
]

const router = new VueRouter({
    mode: 'history',
    routes, // short for `routes: routes`
    linkActiveClass: "active",
    linkExactActiveClass: "exact-active",
})

let Fire = new Vue();
window.Fire = Fire;
import { Form } from 'vform';
window.Vue = require('vue');
window.Form = Form;



import VueOffline from 'vue-offline'
Vue.use(VueOffline)

const app = new Vue({
    el: '#app',
    router,

    data() {
        return {

            events: ['click', 'mousemove', 'mousedown', 'scroll', 'keypress', 'load'],
            sessionTimer: null,

            user_data: {},
            existed_loan: null,

            cares2: new Form({
                step: '',
                application_id: '',
                user_id: '',
                borrower_id: '',
                domain: '',
                account_type: '',
                docver_status: '',
                app_type: '',
            }),

            user: new Form({
                id: null,
                firstname: null,
                lastname: null,
                birthdate: null,
                bus_type: null,
                suffix_code: null,
                domain: null,
            }),

            prereg: new Form({
                step: 1,
                completed: 0,
            }),


        } //return
    }, //data


    methods: {
        setTimers() {
            if (this.user.id) {
                this.sessionTimer = setTimeout(this.session, 60 * 55 * 1000);
            }
        },
        session() {
            Swal.fire({
                icon: 'warning',
                title: 'Session Expired!',
                text: 'Please retry again',
                allowEscapeKey: false,
                allowOutsideClick: false,
                allowEnterKey: false,
                confirmButtonText: 'Ok',
            }).then((result) => {
                if (result) {
                    location.reload();
                }
            })

        },
        resetTimer() {
            clearTimeout(this.sessionTimer);
            this.setTimers();
        },


        getNumMatches(array, predicate) {
            let numMatches = 0;
            for (let i = 0, j = array.length; i < j; i += 1) {
                const current = array[i];
                if (predicate(current) === true) {
                    numMatches += 1;
                }
            }
            return numMatches;
        },
        getExistLoanC3() {
            axios
                .get("/api/exist-loan")
                .then(response => {
                    this.existed_loan = response.data
                    if (this.existed_loan) {
                        this.getPrereg();
                    } else {
                        this.$router.push('cares2-application');
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        },

        getCares2() {
            axios.get('/api/get-initialize')
                .then(response => {
                    if (response.data.length > 0) {
                        this.dataInit = response.data;

                        let last = (last = Object.keys(response.data))[last.length - 1];
                        this.cares2.fill(response.data[last]);

                        // const numFound = this.getNumMatches(this.dataInit, (item) => {
                        //   return item.docver_status === 'DVS05';
                        // });

                        const cares2 = this.getNumMatches(this.dataInit, (item) => {
                            return item.docver_status !== '';
                        });
                        if (cares2 >= 3) {

                            if (!this.cares2.docver_status) {
                                this.getExistLoanC3();

                            } else {
                                this.getPrereg();
                            }

                        } else {
                            if (this.cares2.docver_status == 'DVS05' || this.cares2.app_type == 'APP02') {
                                this.getExistLoanC3();
                            } else {
                                this.getPrereg();
                            }
                        }
                    } else {
                        this.getPrereg();
                    }

                })
                .catch(error => {
                    console.log(error);
                })
        },
        getPrereg() {
            axios
                .get("/api/get-prereg")
                .then(response => {
                    if (response.data.length > 0) {
                        this.prereg.fill(response.data[0]);
                        if (this.prereg.completed != 1) {
                            if (this.user.domain == 'public') {
                                if (this.$route.path !== "/pre-reg") {
                                    this.$router.push('pre-reg')
                                    // window.location.href = 'pre-reg'
                                }
                            }
                        }

                    } else {
                        if (this.user.domain == 'public') {
                            if (this.$route.path !== "/pre-reg") {
                                // window.location.href = 'pre-reg'
                                this.$router.push('pre-reg')
                            }
                        }
                    }

                })
                .catch(error => {
                    console.log(error);
                });
        },

        getInit() {
            const path = this.$route.path;
            const guest = [
                '/password/reset',
                '/email-update',
                '/register',
                '/forgot-account'
            ];
            const url = guest.some(item =>
                path.startsWith(item)
            );

            if (!url) {
                axios
                    .get("/api/user")
                    .then(response => {
                        this.user_data = response.data
                        this.user.fill(response.data);
                        if (this.user) {
                            this.getPrereg();
                            // this.getCares2()
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }
        },

        getUser() {
            axios
                .get("/api/user")
                .then(response => {
                    this.user_data = response.data
                    this.user.fill(response.data);
                })
                .catch(error => {
                    console.log(error);
                });
        },
    },

    created() {
        this.getInit();

        // this.getCares2();

        Fire.$on('UpdateInit', () => {
            this.getInit();
        });

        Fire.$on('UpdatePrereg', () => {
            this.getPrereg();
        });
        // Fire.$on('ExistLoan', () => {
        //   this.getExistLoan();
        // });

        Fire.$on('UserUpdated', () => {
            this.getUser();
        });
        Fire.$on('UpdateFromCares2', () => {
            this.getCares2();
        });


    },
    mounted() {
        this.$on('offline', () => {
            Swal.fire({
                icon: 'error',
                title: 'No Internet Connection',
                text: 'Unable to establish connection. Check your internet connection and try again.',
                allowEscapeKey: false,
                allowOutsideClick: false,
                allowEnterKey: false,
                confirmButtonText: 'Ok',
            }).then((result) => {
                if (result) {
                    location.reload();
                }
            })
        }),

            this.events.forEach(function (event) {
                window.addEventListener(event, this.resetTimer);
            }, this);
        this.resetTimer();
    },
});


// Add a response interceptor
axios.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
}, function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    if (error.response.status === 403 || error.response.status === 401) {
        // redirect to login page
        Swal.fire({
            icon: 'warning',
            title: 'Session Expired!',
            text: 'Please re-login',
            allowEscapeKey: false,
            allowOutsideClick: false,
            allowEnterKey: false,
            confirmButtonText: 'Ok',
        }).then((result) => {
            if (result) {
                // window.location.href = "/";
                location.reload();
            }
        })
    }
    else if (error.response.status === 422) {
        return Promise.reject(error);

    } else {

        axios.interceptors.request.use(function (config) {
            // Do something before request is sent
            return false;
        }, function (error) {
            // Do something with request error
            return Promise.reject(error);
        });

        Swal.fire({
            icon: 'warning',
            title: 'Transaction Failed',
            text: 'Please retry again',
            allowEscapeKey: false,
            allowOutsideClick: false,
            allowEnterKey: false,
            confirmButtonText: 'Ok',
        }).then((result) => {
            if (result) {
                // window.location.href = "/";
                location.reload();
            }
        })
    }
    return Promise.reject(error);
});


Vue.prototype.$swalDQ = () => {
    Swal.fire({
        icon: 'warning',
        title: 'Disqualified',
        text: 'You are not eligible to apply for a loan under this program.',
        allowEscapeKey: false,
        allowOutsideClick: false,
    })
}

Vue.prototype.$setDataObj = (temp, data) => {
    let obj = {}
    for (var key in temp) {
        if (data.hasOwnProperty(key)) {
            obj[key] = data[key];
        }
    }
    return obj;
}

let compiler = process.env.MIX_COMPILER
if (compiler === 'prod') {
    Vue.config.devtools = false;
    Vue.config.debug = false;
    Vue.config.silent = true;
}
